import React from 'react'
import { shallow, mount } from 'enzyme'
import KeyAttributes from '../KeyAttributes'

describe('<KeyAttributes />', () => {
  let wrapper, props
  beforeEach(() => {
    props = {
      keyAttributes: [
        'total_debt_to_rev',
        'calc_net_profit_for_year_CY01',
        'calc_gross_margin_for_year_CY01',
        'OTD_to_attempt_prequal',
        'personal_score_max'
      ],
      needsRedecision: false
    }
    wrapper = shallow(<KeyAttributes {...props} />)
  })
  it('should return null when there are no key attributes', () => {
    props.keyAttributes = []
    expect(KeyAttributes(props)).toBeNull()
  })
  it('should return nothing if the loan needs to be redecisioned', () => {
    props.needsRedecision = true
    expect(KeyAttributes(props)).toBeNull()
  })
  it('should render one list item for each key attribute', () => {
    expect(wrapper.find('KeyAttributes__Item')).toHaveLength(props.keyAttributes.length)
  })
})
